import React from 'react';
import { IconProps } from '../DefaultIcon';

export function CRMIcon({ className }: IconProps) {
  return (
    <svg
      width="80"
      height="75"
      viewBox="0 0 80 75"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g>
        <path
          d="M65.9819 68.8822H2.9003C1.20846 68.8822 0 67.7492 0 66.1631V2.71903Cß0 1.13293 1.20846 0 2.9003 0H65.9819C67.6737 0 68.8822 1.13293 68.8822 2.71903V65.9366C68.8822 67.5227 67.6737 68.8822 65.9819 68.8822Z"
          fill="#EAEEF9"
        />
        <path
          d="M63.8068 11.5559H5.07564C4.35056 11.5559 3.62549 10.8761 3.62549 10.1964V4.7583C3.62549 4.07855 4.35056 3.39879 5.07564 3.39879H63.8068C64.5318 3.39879 65.2569 4.07855 65.2569 4.7583V10.1964C65.2569 10.8761 64.7735 11.5559 63.8068 11.5559Z"
          fill="#00416B"
        />
        <path
          d="M22.4775 59.139H7.25093C6.52586 59.139 5.80078 58.4592 5.80078 57.7795V49.6224C5.80078 48.9426 6.52586 48.2628 7.25093 48.2628H22.4775C23.2026 48.2628 23.9277 48.9426 23.9277 49.6224V57.7795C23.9277 58.6858 23.2026 59.139 22.4775 59.139Z"
          fill="white"
        />
        <path
          d="M22.4775 75H7.25093C6.52586 75 5.80078 74.3202 5.80078 73.6405V65.4834C5.80078 64.8036 6.52586 64.1239 7.25093 64.1239H22.4775C23.2026 64.1239 23.9277 64.8036 23.9277 65.4834V73.6405C23.9277 74.3202 23.2026 75 22.4775 75Z"
          fill="white"
        />
        <path
          d="M78.55 16.994H30.4534C29.7283 16.994 29.0032 17.6737 29.0032 18.3535V29.9094C29.0032 31.4955 27.7947 32.6284 26.1029 32.6284H7.25093C6.52586 32.6284 5.80078 33.3082 5.80078 33.9879V42.145C5.80078 42.8248 6.52586 43.5045 7.25093 43.5045H26.1029C27.7947 43.5045 29.0032 44.6375 29.0032 46.2236V73.4139C29.0032 74.0937 29.7283 74.7734 30.4534 74.7734H78.3083C79.0334 74.7734 79.7585 74.0937 79.7585 73.4139V18.3535C80.0002 17.6737 79.2751 16.994 78.55 16.994Z"
          fill="#00C4B3"
        />
        <path
          d="M22.4775 27.8701H7.25093C6.52586 27.8701 5.80078 27.1903 5.80078 26.5106V18.3535C5.80078 17.6737 6.52586 16.994 7.25093 16.994H22.4775C23.2026 16.994 23.9277 17.6737 23.9277 18.3535V26.5106C23.9277 27.4169 23.2026 27.8701 22.4775 27.8701Z"
          fill="white"
        />
        <path
          d="M7.97603 8.83686C8.77693 8.83686 9.42618 8.22819 9.42618 7.47734C9.42618 6.7265 8.77693 6.11783 7.97603 6.11783C7.17513 6.11783 6.52588 6.7265 6.52588 7.47734C6.52588 8.22819 7.17513 8.83686 7.97603 8.83686Z"
          fill="#FBFCFE"
        />
        <path
          d="M13.7763 8.83686C14.5772 8.83686 15.2265 8.22819 15.2265 7.47734C15.2265 6.7265 14.5772 6.11783 13.7763 6.11783C12.9754 6.11783 12.3262 6.7265 12.3262 7.47734C12.3262 8.22819 12.9754 8.83686 13.7763 8.83686Z"
          fill="#FBFCFE"
        />
        <path
          d="M19.5771 8.83686C20.378 8.83686 21.0273 8.22819 21.0273 7.47734C21.0273 6.7265 20.378 6.11783 19.5771 6.11783C18.7762 6.11783 18.127 6.7265 18.127 7.47734C18.127 8.22819 18.7762 8.83686 19.5771 8.83686Z"
          fill="#FBFCFE"
        />
        <path
          d="M46.8883 31.0423H38.9124C36.0121 31.0423 33.3535 28.7764 33.3535 25.8308C33.3535 23.1118 35.7704 20.6193 38.9124 20.6193H46.8883C49.7886 20.6193 52.4472 22.8852 52.4472 25.8308C52.2055 28.7764 49.7886 31.0423 46.8883 31.0423Z"
          fill="white"
        />
        <path
          d="M70.0904 31.0423H62.1146C59.2143 31.0423 56.5557 28.7764 56.5557 25.8308C56.5557 23.1118 58.9726 20.6193 62.1146 20.6193H70.0904C72.9907 20.6193 75.6493 22.8852 75.6493 25.8308C75.6493 28.7764 72.9907 31.0423 70.0904 31.0423Z"
          fill="#FBFCFE"
        />
        <path
          d="M54.3808 67.5227C53.1723 67.5227 52.2056 66.6163 52.2056 65.4834V38.7462C52.2056 37.6133 53.1723 36.707 54.3808 36.707C55.5893 36.707 56.556 37.6133 56.556 38.7462V65.2568C56.556 66.3897 55.5893 67.5227 54.3808 67.5227Z"
          fill="white"
        />
        <path
          d="M58.006 47.3565H50.7553C49.0634 47.3565 47.855 46.2236 47.855 44.6375C47.855 43.0514 49.0634 41.9184 50.7553 41.9184H58.006C59.6979 41.9184 60.9063 43.0514 60.9063 44.6375C60.9063 45.997 59.6979 47.3565 58.006 47.3565Z"
          fill="#EAEEF9"
        />
        <path
          d="M68.1572 67.5227C66.9487 67.5227 65.9819 66.6163 65.9819 65.4834V38.7462C65.9819 37.6133 66.9487 36.707 68.1572 36.707C69.3656 36.707 70.3324 37.6133 70.3324 38.7462V65.2568C70.5741 66.3897 69.3656 67.5227 68.1572 67.5227Z"
          fill="white"
        />
        <path
          d="M72.0241 62.3112H64.7733C63.0815 62.3112 61.873 61.1782 61.873 59.5921C61.873 58.006 63.0815 56.8731 64.7733 56.8731H72.0241C73.7159 56.8731 74.9244 58.006 74.9244 59.5921C74.9244 61.1782 73.4743 62.3112 72.0241 62.3112Z"
          fill="#EAEEF9"
        />
        <path
          d="M40.6044 67.5227C39.396 67.5227 38.4292 66.6163 38.4292 65.4834V38.7462C38.4292 37.6133 39.396 36.707 40.6044 36.707C41.8129 36.707 42.7797 37.6133 42.7797 38.7462V65.2568C42.7797 66.3897 41.8129 67.5227 40.6044 67.5227Z"
          fill="white"
        />
        <path
          d="M44.2297 56.4199H36.9789C35.2871 56.4199 34.0786 55.287 34.0786 53.7009C34.0786 52.1148 35.2871 50.9819 36.9789 50.9819H44.2297C45.9215 50.9819 47.13 52.1148 47.13 53.7009C47.13 55.287 45.9215 56.4199 44.2297 56.4199Z"
          fill="#EAEEF9"
        />
        <path
          d="M38.9125 29.2296C40.9147 29.2296 42.5379 27.7079 42.5379 25.8308C42.5379 23.9537 40.9147 22.432 38.9125 22.432C36.9102 22.432 35.2871 23.9537 35.2871 25.8308C35.2871 27.7079 36.9102 29.2296 38.9125 29.2296Z"
          fill="#00C4B3"
        />
        <path
          d="M70.0907 29.2296C72.093 29.2296 73.7161 27.7079 73.7161 25.8308C73.7161 23.9537 72.093 22.432 70.0907 22.432C68.0885 22.432 66.4653 23.9537 66.4653 25.8308C66.4653 27.7079 68.0885 29.2296 70.0907 29.2296Z"
          fill="#00416B"
        />
      </g>
      <defs>
        <clipPath id="clip0_4_2125">
          <rect width="80" height="75" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
